module.exports = __webpack_public_path__ + "static/media/expand.af14bd33.svg";